import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { deleteDocumentacaoAVCB } from "./services";

interface UploadState {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  responseData: any | null;
}

const initialState: UploadState = {
  status: "idle",
  error: null,
  responseData: null,
};

export const deleteDocumentacaoAVCBById = createAsyncThunk<
  any,
  number,
  { rejectValue: string }
>(
  "upload/deleteDocumentacaoAVCB",

  async (id, { rejectWithValue }) => {
    try {
      const data = await deleteDocumentacaoAVCB(id);
      return data;
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message || "Falha ao deletar o arquivo.";
      return rejectWithValue(errorMessage);
    }
  },
);

const sliceDeleteDocumentacaoAVCB = createSlice({
  name: "deleteDocumentacaoAVCB",
  initialState,
  reducers: {
    resetDeleteDocumentacaoAVCBState: (state) => {
      state.status = "idle";
      state.error = null;
      state.responseData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDocumentacaoAVCBById.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.responseData = null;
      })
      .addCase(
        deleteDocumentacaoAVCBById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "success";
          state.responseData = action.payload;
        },
      )
      .addCase(
        deleteDocumentacaoAVCBById.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload || "Ocorreu um erro desconhecido.";
        },
      );
  },
});

export const { resetDeleteDocumentacaoAVCBState } =
  sliceDeleteDocumentacaoAVCB.actions;
export default sliceDeleteDocumentacaoAVCB.reducer;
